// extracted by mini-css-extract-plugin
export default {"wrapper":"cardListProjectManagers_wrapper__whyWx","list":"cardListProjectManagers_list__t0hvP"};